module.exports = __webpack_public_path__ + "static/img/menu5.7b6e2237.png";